import api from "@/services/api";
import { Component, Prop, Watch } from "vue-property-decorator";
import { schedulerItemViewModel } from "../models/schedulerItemViewModel";
import { dayOfWeek } from "../enums/dayOfWeek";
import { dayOfWeekModel } from "@/models/daysOfWeekModel";
import helpers from "../utils";
import { groupItem } from "../models/groupItem";
import { importConfig } from "@/models/tableConfigs";
import { schedulingItem } from "../models/schedulingItem";
import baseContextComponent from "@/components/baseContextComponent";

@Component({})
export default class scheduerPage extends baseContextComponent {
	schedules: schedulerItemViewModel[] = [];
	groups: groupItem[] = [];
	tableConfigs: importConfig[] = [];
	searchSchedule: string = null;
	daysOfWeekArray: dayOfWeekModel[] = [];
	selectedTime: string = "";

	schedulesSelected: schedulerItemViewModel = new schedulerItemViewModel();

	showModalNewSchedule: boolean = false;
	newSchedule: schedulerItemViewModel = new schedulerItemViewModel();
	schedulesNewSaveClick: boolean = false;
	schedulesNewSaveLoading: boolean = false;
	//lasciare per futuro refactory
	get showLeftColumn(): boolean {
		var self = this;
		// return (
		// 	self.isSmallScreen == false ||
		// 	self.tableName == null || self.tableName == ""
		// );
		return true;
	}
	//lasciare per futuro refactory
	get showRightColumn(): boolean {
		var self = this;
		// return (
		// 	self.isSmallScreen == false ||
		// 	(self.tableName != null && self.tableName != "")
		// );
		return true;
	}
	get scheduleList(): schedulerItemViewModel[] {
		var self = this;
		if (self.schedules == null) return [];
		if (self.searchSchedule == null) return self.schedules;
		var filtered = self.schedules.filter(x => (x.name || "").indexOf(self.searchSchedule) != -1);
		return filtered;
	}

	get scheduleNewDescriptionValidation(): boolean {
		if (!this.schedulesNewSaveClick) return null;
		return this.newSchedule.name.length > 0;
	}

	get scheduleName(): string {
		return this.schedulesSelected && this.schedulesSelected.name ? this.schedulesSelected.name : "seleziona una schedulazione per configurarla";
	}

	created() {
		var self = this;

		for (let day in dayOfWeek) {
			let d = new dayOfWeekModel(day, helpers.GetDayNameByWeekDay(day));
			this.daysOfWeekArray.push(d);
		}

		self.fetch();
	}
	fetch() {
		var self = this;

		api.getGroupings().then(data => {
			self.groups = data.groups;

			self.tableConfigs = [];
			data.tables
				.filter(item => {
					return item.configs && item.configs.length > 0;
				})
				.map(item => {
					return {
						configs: item.configs
					};
				})
				.forEach(item => {
					self.tableConfigs = self.tableConfigs.concat(item.configs);
				});
		});

		api.getSchedules().then((data: schedulerItemViewModel[]) => {
			self.schedules = data;
		});
	}

	setScheduleSelected(s: schedulerItemViewModel) {
		this.schedulesSelected = s;
	}

	isActive(s: schedulerItemViewModel) {
		return s != null && s.name == this.scheduleName;
	}

	openModalNewSchedule() {
		this.newSchedule = new schedulerItemViewModel();
		this.showModalNewSchedule = true;
	}

	onSaveNewSchedule() {
		if (this.newSchedule.name.length == 0) {
			this.schedulesNewSaveClick = true;
			this.$bvToast.toast("la descrizione è obbligatoria", {
				variant: "danger",
				title: "ATTENZIONE",
				solid: true
			});
			return null;
		}

		var self = this;
		api.saveNewSchedule(this.newSchedule).then(res => {
			self.onCancelNewSchedule();
			self.newSchedule = new schedulerItemViewModel();
			self.fetch();
		});
	}

	onCancelNewSchedule() {
		this.newSchedule = new schedulerItemViewModel();
		this.showModalNewSchedule = false;
		this.schedulesNewSaveClick = false;
	}

	onDelete() {
		var self = this;
		this.$bvModal
			.msgBoxConfirm(`Sei sicuro di eliminare la schedulazione ${this.schedulesSelected.name} ?`, {
				title: "ATTENZIONE",
				okTitle: "SI",
				cancelTitle: "NO",
				footerClass: "p-2",
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if (value) {
					api.deleteSchedule(this.schedulesSelected.itemID).then(res => {
						self.schedulesSelected = new schedulerItemViewModel();
						self.fetch();
					});
				}
			})
			.catch(err => {});
	}
	onSave() {
		var self = this;
		api.updateSchedule(this.schedulesSelected).then(res => {
			this.$bvToast.toast("Salvataggio eseguito con successo", {
				variant: "success",
				title: "Operazione eseguita",
				solid: true
			});

			self.schedulesSelected = new schedulerItemViewModel();
			self.fetch();
		});
	}

	clearTime() {
		this.selectedTime = "";
	}

	addExecuteHour() {
		var re = new RegExp("^(([0-1]?[0-9]|2[0-3]):[0-5][0-9])|(([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9])$");
		if (this.selectedTime && re.test(this.selectedTime)) {
			let time = this.selectedTime;
			let timeSpl = time.split(":");
			if (timeSpl.length > 2) {
				time = `${timeSpl[0]}:${timeSpl[1]}`;
			}
			if (this.schedulesSelected.scheduling.executeTimes.indexOf(time) >= 0) {
				this.$bvToast.toast("orario già presente", {
					variant: "danger",
					title: "ATTENZIONE",
					solid: true
				});

				return null;
			}

			this.schedulesSelected.scheduling.executeTimes.push(time);
		} else {
			this.$bvToast.toast("orario non valido", {
				variant: "danger",
				title: "ATTENZIONE",
				solid: true
			});
		}
	}

	removeAtIndex(index: number) {
		if (index >= 0) {
			this.schedulesSelected.scheduling.executeTimes.splice(index, 1);
		}
	}

	onDemandScheduleConfirm(schedule: schedulerItemViewModel) {
		var self = this;
		this.$bvModal
			.msgBoxConfirm(`Sei sicuro di voler eseguire ORA la schedulazione: ${schedule.name} ?`, {
				title: "ATTENZIONE",
				okTitle: "SI",
				cancelTitle: "NO",
				footerClass: "p-2",
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if (value) {
					api.executeOnDemand(schedule.itemID).then(res => {
						this.$bvToast.toast("La schedulazione è in fase di avviamento", {
							variant: "success",
							title: "Operazione eseguita",
							solid: true
						});

						self.schedulesSelected.onDemand = true;
					});
				}
			})
			.catch(err => {});

		return false;
	}

	getExecutionDay(s: schedulerItemViewModel) {
		if (s.scheduling && s.scheduling.dayOfWeeks && s.scheduling.dayOfWeeks.length > 0) {
			var dds = s.scheduling.dayOfWeeks.map(item => {
				return helpers.GetDayNameByWeekDay(item);
			});
			return dds.join();
		}
	}

	getExecutionTimes(s: schedulerItemViewModel) {
		var self = this;
		if (s.scheduling && s.scheduling.executeTimes && s.scheduling.executeTimes.length > 0) {
			return s.scheduling.executeTimes
				.map(item => {
					return self.$options.filters.timeStringToStringHHmm(item);
					// return self.$options.filters.formatDate(item,'time');
				})
				.join();
		}
	}
}
